module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm04"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Prologue")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("June 1, 1861")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A")])]), _vm._v("manda Deveaux looked at the cameo in her hand. Embossed on the delicate Wedgwood-blue oval was the profile of a young Greek woman, carved in ivory. It was the most beautiful thing she had ever seen, even though her vision was blurred because of the tears in her eyes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("She gazed up at the man who had given the cameo to her. Lt. William Slattery of the Confederate Army. Her Will, dashingly handsome in his new gray uniform, a uniform she had sewn for him herself. She was ach")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("ingly proud of him for what he was about to do. And heartsick about it at the same time.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I want you to wear this, Amanda.” Will took the cameo from her and tied the black velvet ribbon at the back of her neck. “Promise me that you’ll wear it until I can come home to make you my bride.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But why can’t I marry you now?” she pleaded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Will glanced over at the stone-faced woman who stood several feet away, guarding her precious daughter. “Because,” he told her, “a lady doesn’t hurriedly get married like some penniless servant girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Amanda didn’t care about tradition, only that the man she loved was going away for who knew how long. “I don’t want to be a lady. I want to be your wife.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’ll be both when I come back. Promise you’ll wait for me,” he repeated.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She clutched his hand, ignoring her mother’s reproving looks. Her mother had never liked Will. His family didn’t have enough money to suit her. As if money could ever be the measure of a man’s worth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You know I will. From the first moment I saw you until the last moment I’ll draw breath, there’s only you, my darling,” she whispered to him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Will kissed her hand in the tradition of the times. And then, because he was young and in love and this would be the last time that they would be together, he drew her into his arms and kissed the woman he’d loved since he was a small boy.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("He kissed her long and hard, fashioning a moment ")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("and a memory that would last him through however many days and weeks and months he would have to be away. He had to fight a war he had never asked for. A war that his young honor demanded he fight. He hadn’t bought his way out the way some others of his class had. They had sent in paid substitutes to fight in their places. To die in their stead if that was the way of it.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The son of a very small plantation owner, Will’s honor forbade him to allow others to brave danger in his place. But, oh, his heart felt as if it was breaking as he stood there, the April wind ruffling his hair, kissing the woman he would rather have died for than leave.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I believe it is time to take your leave, Lieutenant,” Belinda Deveaux told him sharply.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He took a step back and looked at Amanda, sealing her image in his mind. “Wait for me,” he begged her again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Forever if I have to.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Clutching the cameo to her, Amanda waved as Will mounted his horse and then rode away. She waved until the horse and rider had long disappeared from view.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Amanda ignored the disparaging sound her mother made. It faded into the background, muted by the sound of her breaking heart.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Forever,” she repeated in a fierce whisper.")])])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page09"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-acee721c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426870439_fm04.vue
// module id = 78
// module chunks = 0